import { render, staticRenderFns } from "./previewModal.vue?vue&type=template&id=08b8a0da&scoped=true"
import script from "./previewModal.vue?vue&type=script&lang=js"
export * from "./previewModal.vue?vue&type=script&lang=js"
import style0 from "./previewModal.vue?vue&type=style&index=0&id=08b8a0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b8a0da",
  null
  
)

export default component.exports